import React from 'react';
import { tp } from 'app/utils/typograf';
import { dishes as easterDishes } from '../../../../../../../../global/const/easter';

interface IUpsellItem {
    type: 'link' | 'button' | 'custom',
    title: React.ReactElement,
    description: React.ReactElement,
    selectionDescription?: React.ReactElement,
    linkDescription?: React.ReactElement,
    selectionTitle?: React.ReactElement,
    linkTitle?: React.ReactElement,
    href?: string,
    tag?: string,
    savingDeliveryСartText?: string,
    selectionDishes?: Array<string>,
    id?: string
}

const halloweenUpsell: IUpsellItem = {
    type: 'link',
    tag: 'halloween',
    href: '/halloween/?save=dishes&?erid=2SDnjchK4sW',
    title: (
        <>
            {tp.execute('Страшно вкусный бокс на Хэллоуин')}
        </>
    ),
    description: (
        <>
            {tp.execute('Настоящая вечеринка всего за час — ужасно вкусные блюда, паутины, летучие мыши и, конечно, тыквенная голова Джека.')}
        </>
    ),
};

const maslenitsaUpsell: IUpsellItem = {
    type: 'button',
    tag: 'maslenitsa',
    title: (
        <>
            Масленица со 100 подарками от Tefal
        </>
    ),
    description: (
        <>
            {tp.execute('Блины сытные или сладкие, уже готовые или самодельные, чтобы устроить пир за считанные минуты')}
        </>
    ),
    savingDeliveryСartText: 'набор для широкой масленицы',
};

const greenUpsell: IUpsellItem = {
    type: 'button',
    tag: '1220',
    title: (
        <>
            Лёгкий подход
            <br />
            к лёгкой еде
        </>
    ),
    description: (
        <>
            <li>Много белка и овощей</li>
            <li>Баланс БЖУ на 400-500 ккал</li>
            <li>Новые интересные продукты!</li>
        </>
    ),
};

const romanticUpsell: IUpsellItem = {
    type: 'link',
    href: '/romantic/',
    title: (
        <>
            Время для свиданий дома
        </>
    ),
    description: (
        <>
            {tp.execute('Всё для романтического вечера: от рецептов и продуктов до салфеток-сердечек для сервировки и тем для душевных разговоров.')}
        </>
    ),
    savingDeliveryСartText: 'романтический ужин',
};

const marchgiftsUpsell: IUpsellItem = {
    type: 'link',
    href: '/marchgifts/',
    title: (
        <>
            Подарочный бокс
            <br />
            на 8 марта
        </>
    ),
    description: (
        <>
            Набор с несъедобными ингредиентами и пошаговым рецептом для полного релакса
        </>
    ),
    savingDeliveryСartText: 'подарки к 8 марта',
};

const marchsUpsell: IUpsellItem = {
    type: 'button',
    tag: 'march',
    title: (
        <>
            Великие женщины
        </>
    ),
    description: (
        <>
            Посвящаем эти блюда выдающимся женщинам 20 века. Пусть они вдохновят на великие дела и вас!
        </>
    ),
};

const easterUpsell: IUpsellItem = {
    type: 'custom',
    href: '/easterbox/',
    tag: 'easter',
    title: (
        <>
            Празднуем Пасху
        </>
    ),
    linkTitle: (
        <>
            Оформите предзаказ
            <br />
            на Пасху
        </>
    ),
    selectionTitle: (
        <>
            Время праздновать Пасху
        </>
    ),
    description: (
        <>
            Привезем всё необходимое,
            чтобы испечь роскошные куличи, покрасить яйца натуральными красителями, накрыть праздничный стол.
        </>
    ),
    selectionDescription: (
        <>
            Привезём всё необходимое, чтобы испечь роскошные куличи, покрасить яйца натуральными красителями, накрыть праздничный стол.
        </>
    ),
    linkDescription: (
        <>
            Привезём к празднику всё, чтобы испечь роскошные куличи, покрасить яйца натуральными красителями и накрыть стол
        </>
    ),
    selectionDishes: easterDishes,
};

const dachaUpsell: IUpsellItem = {
    type: 'link',
    href: '/dacha/',
    title: (
        <>
            Едем
            {' '}
            <br />
            на шашлыки
        </>
    ),
    description: (
        <>
            {tp.execute('Привезём всё, чтобы устроить пикник или ужин на даче без забот: замариновали мясо, приготовили соусы от шефа, добавили свежие овощи, зелень и ароматные питы.')}
        </>
    ),
};

const squidgameUpsell: IUpsellItem = {
    type: 'link',
    href: '/squid-game/',
    title: (
        <>
            По мотивам сериала
            <br />
            «Игра в кальмара»
        </>
    ),
    description: (
        <>
            Хиты корейской кухни и то самое печенье Дальгона из карамели, чтобы устроить свою игру!
        </>
    ),
};

const wednesdayUpsell: IUpsellItem = {
    type: 'link',
    href: '/squid-game/',
    title: (
        <>
            Сладкая вечеринка
            <br />
            Уэнсдей
        </>
    ),
    description: (
        <>
            Хиты корейской кухни и то самое печенье Дальгона из карамели, чтобы устроить свою игру!
        </>
    ),
};

const filmUpsell: IUpsellItem = {
    type: 'link',
    href: '/film/',
    title: (
        <>
            Дома
            <br />
            как в кино
        </>
    ),
    description: (
        <>
            {tp.execute('Когда хочется перенестись в другую вселенную')}
            <br />
            {tp.execute(' и во время просмотра ')}
            <br />
            {tp.execute('разделить с главными героями ')}
            <br />
            {tp.execute('ужин из кино.')}
        </>
    ),
};

const hpUpsell: IUpsellItem = {
    type: 'button',
    tag: 'hp',
    title: (
        <>
            Меню
            <br />
            из Хогвартса
        </>
    ),
    description: (
        <>
            {tp.execute('Переносимся во вселенную Гарри: на пир в школу чародейства и волшебства, уютный обед у миссис Уизли или чаепитие у Хагрида.')}
        </>
    ),
};

const nyUpsell: IUpsellItem = {
    type: 'link',
    href: '/christmas/',
    title: (
        <>
            Рождественское настроение
        </>
    ),
    description: (
        <>
            {tp.execute('Представьте, что у вас есть волшебные эльфы, с которыми вы легко и быстро приготовите шикарный праздничный стол. Осталось лишь выбрать блюда')}
        </>
    ),
};

const fastUpsell: IUpsellItem = {
    type: 'button',
    tag: '2121',
    title: (
        <>
            Блюда из растительных
            <br />
            продуктов
        </>
    ),
    description: (
        <>
            {tp.execute('Продумали меню с питательным составом, чтобы помочь вам организовать питание в пост!')}
        </>
    ),
};

const odysseyUpsell: IUpsellItem = {
    type: 'button',
    tag: 'odyssey',
    // type: 'link',
    // href: '/theodyssey/',
    title: (
        <>
            Еда богов и странников
            <br />
            из «Одиссеи» Нолана
        </>
    ),
    description: (
        <>
            {tp.execute('Погрузитесь в атмосферу эпоса с ужинами для героев легендарного путешествия')}
        </>
    ),
};

const gryadkaUpsell: IUpsellItem = {
    type: 'button',
    tag: 'gryadka',
    // type: 'link',
    // href: '/theodyssey/',
    title: (
        <>
            Всё, что хочется летом —
            <br />
            прямо с грядки
        </>
    ),
    description: (
        <>
            {tp.execute('Салат из свежих овощей, корзинка спелых сезонных ягод и окрошка, как у бабушки.')}
        </>
    ),
};

const schoolUpsell: IUpsellItem = {
    tag: 'school',
    type: 'button',
    id: '5505',
    title: (
        <>
            Авоська
            <br />
            воспоминаний
        </>
    ),
    description: (
        <>
            {tp.execute('Ностальгический подарок, который возвращает в детство без электронных дневников и гаджетов')}
        </>
    ),
};

const harryUpsell: IUpsellItem = {
    tag: 'hp',
    type: 'button',
    id: 'harry',
    title: (
        <>
            Еда и сладости
            <br />
            из Хогвартса
        </>
    ),
    description: (
        <>
            {tp.execute('Уютные обеды у миссис Уизли, «каменное» печенье Хагрида, любимый пирог Гарри и другие блюда из Вселенной Гарри.')}
        </>
    ),
};

export const setsWithFirstPeriodInFuture = ['easter', 'halloween', 'ny', 'romantic', 'maslenitsa'];

export const upsellHashMap = new Map([
    ['maslenitsa', maslenitsaUpsell],
    ['romantic', romanticUpsell],
    ['marchgifts', marchgiftsUpsell],
    ['green', greenUpsell],
    ['march', marchsUpsell],
    ['easter', easterUpsell],
    ['dacha', dachaUpsell],
    ['squidgame', squidgameUpsell],
    ['wednesday', wednesdayUpsell],
    ['film', filmUpsell],
    ['halloween', halloweenUpsell],
    ['hp', hpUpsell],
    ['ny', nyUpsell],
    ['odyssey', odysseyUpsell],
    ['gryadka', gryadkaUpsell],
    ['school', schoolUpsell],
    ['harry', harryUpsell],
]);
